import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { saveData, prefersReducedMotion } from '../utilities/constants'

gsap.registerPlugin(ScrollTrigger)

export default class {
  constructor(el) {
    const revealEls = el.querySelectorAll('.js-reveal')

    if (saveData || prefersReducedMotion) {
      revealEls.forEach((revealEl) => {
        gsap.set(revealEl, {
          clearProps: true,
        })
      })

      return
    }

    revealEls.forEach((revealEl) => {
      const revealConfig = {
        delay: Number(revealEl?.dataset?.delay || 0),
        duration: Number(revealEl?.dataset?.duration || 0.9),
        // origin: revealEl?.dataset?.origin || 'bottom',
        // scale: Number(revealEl?.dataset?.scale || 1),
        // scrub: Boolean(revealEl?.dataset?.scrub || false),
        distance: Number(revealEl?.dataset?.distance || 20),
        ease: 'power3.out',
        // trigger: revealEl?.dataset?.trigger
        //   ? revealEl.closest(revealEl.dataset.trigger)
        //   : revealEl,
      }

      if (!revealConfig?.trigger) {
        revealConfig.trigger = revealEl
      }

      gsap.fromTo(
        revealEl,
        {
          y: revealConfig.distance,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: revealConfig.duration,
          delay: revealConfig.delay,
          ease: revealConfig.ease,
          onComplete: () => {
            gsap.set(revealEl, {
              clearProps: true,
            })
          },
          scrollTrigger: {
            trigger: revealConfig.trigger,
            start: 'bottom bottom',
            once: true,
          },
        },
      )
    })
  }
}
